/* eslint-disable no-unused-vars */
import { Common, device } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Flex, Iconmoon } = Common;

const BarWrapper = styled(Flex).attrs({
  align: 'center',
  height: '38px',
  justify: 'space-between',
  width: '100%',
})`
  background-color: rgba(147,67,200,.08);
  cursor: pointer;
  padding: 0px 18px;

  @media ${device.tablet} {
    padding: 0 18px;
  }
`;

interface TagWrapperProps {
  size: 'small' | 'medium' | 'large';
  [key: string]: any;
}

const TagWrapper = styled(Flex).attrs((props: TagWrapperProps) => ({
  align: 'center',
  justify: 'center',
}))`
  height: 12px;
  margin: 0 4px;
  width: 12px;

  & > img {
    width: 100%;
  }

  ${({ size }) =>
    size === 'medium' &&
    css`
      height: 16px;
      width: 16px;
    `}

  ${({ size }) =>
    size === 'large' &&
    css`
      height: 20px;
      width: 20px;
    `}

    ${({ isCorpActionBadges }) =>
    isCorpActionBadges &&
    css`
      margin-right: 0;
    `
  }
`;

const ICON_ARROW_COLOR = '#9343c8';
const IconArrow = styled(Iconmoon)`
  color: ${ICON_ARROW_COLOR};
  font-size: 12px;

  &:before {
    content: "\\e968";
  }

  &:hover {
    color: ${ICON_ARROW_COLOR};
  }
`;

export { TagWrapper, BarWrapper, IconArrow };
